import { observable, observe, action } from 'mobx';
import includes from 'lodash/includes';
import isPlainObject from 'lodash/isPlainObject';

const propertiesList = ['childComponentString', 'childVariationString', 'isModalClosable', 'modalType', 'isModalOpen'];

export default class ModalClass {
    // which child component to load into modal
    @observable childComponentString = null;
    // (optional) variation of child component to be accessed from child component (e.g. "Transfer")
    @observable childVariationString = null;
    // is the user is able to close the modal
    @observable isModalClosable = true;
    // whether or not to show the modal/blocker
    @observable isModalOpen = false;
    // type of modal (small, medium, large)
    @observable modalType = 'medium';


    constructor() {
        // whenever the modal opens/close
        observe(this, 'isModalOpen', () => {
            if (!this.isModalOpen) {
                // reset child variation string after a modal is closed
                this.setModalOptions({ childVariationString: null });
            }
        });
    }

    // set observable options
    @action setModalOptions(obj) {
        if (isPlainObject(obj)) {
            // loop through each option
            propertiesList.forEach((obs) => {
                // if object key matches observable
                if (includes(Object.keys(obj), obs)) {
                    // set observable with that value
                    this[obs] = obj[obs];
                }
            });
        }
    }
}
